import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import { cn } from '@/utils'

interface FoldToggleProps {
  folded: boolean
  onToggle: () => void
  className?: string
}

export const FoldToggle = ({
  folded,
  onToggle,
  className,
}: FoldToggleProps) => (
  <Button
    theme="ghost"
    size="sm"
    className={cn('shrink-0', className)}
    onClick={onToggle}
  >
    {folded ? <ChevronUpIcon /> : <ChevronDownIcon />}
    {folded ? 'Show pages' : 'Hide pages'}
  </Button>
)
